import { Component, computed } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { Overlay } from '@angular/cdk/overlay';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'DocumentPortal';
  
  constructor(public authService: AuthService, public overlay: Overlay, public router: Router) {}
  
  isAssessmentApp(): boolean {
    return this.router.url.startsWith('/assessment');
  }
  
  showHeader = computed(() => {
    return !this.router.url.startsWith('/404');
  });

  showFooter = computed(() => {
    return !this.router.url.startsWith('/404');
  });
    

  
}
